import { ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import { PlaylistsModel } from '@modules/entertainment/models/playlists.model';

export const getPlaylists = async (
  params?: any
): Promise<ApiResponse<PlaylistsModel>> => {
  const response = await axiosInstance.get('/media/playlists/getter', {
    params
  });
  return response.data;
};

export const createPlaylist = async (
  body?: any
): Promise<ApiResponse<PlaylistsModel>> => {
  return await axiosInstance.post(`/media/playlists`, body);
};

export const editPlaylistRow = async (
  body?: any
): Promise<ApiResponse<PlaylistsModel>> => {
  return await axiosInstance.put(`/media/playlists/${body._id}`, body);
};

export const deletePlaylist = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/playlists/${id}`);
};

export const deletePlaylistsMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/media/playlists/many`, { data });
};
